var map = {
	"./clean_cities_accelerator.png": 6406,
	"./climate_kic_small_grayscale.png": 5951,
	"./creative_destruction_lab.png": 6373,
	"./ffg.svg": 7706,
	"./mass_challenge.png": 4623,
	"./mass_challenge_finalist.png": 2124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;